import pirate from './pirate.gif';
import spaceExplorer from './spaceExplorer.gif';
import wizard from './wizard.gif';
import pirateAnimation from './pirateAnimation.gif';
import spaceExplorerAnimation from './spaceExplorerAnimation.gif';
import wizardAnimation from './wizardAnimation.gif';


const characterSelectionAssets = [
  {
    avatar: 'wizard',
    imgSrc: wizard,
    secondaryImgSrc: wizardAnimation,
  }, 
  {
    avatar: 'space explorer',
    imgSrc: spaceExplorer,
    secondaryImgSrc: spaceExplorerAnimation,
  },
  {
    avatar: 'pirate',
    imgSrc: pirate,
    secondaryImgSrc: pirateAnimation,
  },
]

export { characterSelectionAssets }

